// extracted by mini-css-extract-plugin
module.exports = {"loaderWrapper":"ActiveOrders_loaderWrapper__2B1mz"};